import React, { useState, useEffect } from 'react';
import {
    Table,
    Button,
    message,
    Space,
    QRCode as AntdQRCode,
} from 'antd';
import {
    EyeOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import QRCode from 'qrcode';
import constants from './constants/constants';

const App = () => {
    const [birds, setBirds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const navigate = useNavigate();

    const fetchBirds = async () => {
        setLoading(true);
        try {
            fetch(`${constants.ApiUrl}/get-birds-list`)
                .then((res) => res.json())
                .then((data) => setBirds(data.data));
        } catch (error) {
            console.error(error);
            message.error('Failed to load bird list');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBirds();
    }, []);

    const downloadAllQRCodes = async () => {
        setDownloading(true);
        const zip = new JSZip();
        const folder = zip.folder("qr_codes");
    
        for (const bird of birds) {
            const url = `${constants.webLink}${bird.id}`;
            try {
                const dataUrl = await QRCode.toDataURL(url, {
                    width: 300,
                    margin: 1 // Reduce padding (set to 0 for no padding)
                });
                const base64Data = dataUrl.split(',')[1];
                folder.file(`${bird.id}.png`, base64Data, { base64: true });
            } catch (err) {
                console.error(`Failed to generate QR for ${bird.id}`, err);
            }
        }
    
        const blob = await zip.generateAsync({ type: 'blob' });
        saveAs(blob, 'qr_codes.zip');
        setDownloading(false);
    };    

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Birds',
            dataIndex: 'common_name',
            key: 'common_name',
            render: (_, record) => (
                <div>
                    {record.common_name}{' '}
                    {record.other_common_names && (
                        <span className='text-gray-400'>({record.other_common_names})</span>
                    )}
                    <div>
                        <small><i>{record.scientific_name}</i></small>
                    </div>
                </div>
            ),
        },
        // {
        //     title: 'QR Code',
        //     key: 'qrCode',
        //     render: (_, record) => (
        //         <AntdQRCode
        //             value={`${constants.webLink}${record.id}`}
        //             size={100}
        //         />
        //     ),
        // },
        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        onClick={() => window.open(`/${record.id}`, '_blank')}
                        icon={<EyeOutlined />}
                    >
                        View
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <div className="container mx-auto p-4">
            {/* Hero Section */}
            <div className="text-center mb-6">
                <h1 className="text-5xl font-bold mb-4">Birds of Goa</h1>
                <p className="text-lg mb-6 text-gray-600">
                    Discover the vibrant avian diversity of Goa with this beautifully illustrated celebration of its birdlife.
                </p>
                <Button type='primary' size='large' className="bg-green-900 hover:!bg-green-950">
                    Buy Now
                </Button>
            </div>

            <div className="mb-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold">List of birds of Goa</h2>
                {/* <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={downloadAllQRCodes}
                    loading={downloading}
                    disabled={birds.length === 0}
                >
                    Download All QR Codes
                </Button> */}
            </div>

            <Table
                columns={columns}
                dataSource={birds}
                loading={loading}
                rowKey="id"
                size="small"
                pagination={{ pageSize: 10 }}
            />
        </div>
    );
};

export default App;
